<template>
  <!-- Toast Message -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false" />

  <div class="row">
    <div class="col-12">
      <div class="d-flex align-items-center">
        <h5 class="mb-0 text-primary">
          <i class="text-primary fa fa-line-chart"></i> Marks
        </h5>
      </div>
      <hr />
      <div class="row g-3">
        <div class="col-md-3">
          <label class="form-label">
            Class<sup><span class="text-danger font-12">*</span></sup> :
          </label>
          <div class="dropdown">
            <button class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a" type="button"
              data-bs-toggle="dropdown" aria-expanded="false">
              {{clsList.find((c) => c._id === Obj.clsID)?.name || ""}}
            </button>
            <ul class="dropdown-menu w-100 scrollable-menu">
              <li v-for="(item, index) in uniqueClsList" :key="index">
                <a class="dropdown-item" href="#" @click.prevent="changeClass(item._id)">
                  {{ item.name }}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md-3">
          <label class="form-label">Section<sup><span class="text-danger font-12">*</span></sup>
            :</label>
          <select v-model="Obj.sectionID" class="form-select form-select-sm rounded cursor-pointer" role="button"
            @change="loadStudents()">
            <option selected=""></option>
            <option v-for="(item, index) in secList" :key="index" :value="item._id">
              {{ item.Name }}
            </option>
          </select>
        </div>

        <div class="col-md-3">
          <label class="form-label">
            Exam Type<sup><span class="text-danger font-12">*</span></sup> :
          </label>
          <div class="dropdown">
            <button class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a" type="button"
              data-bs-toggle="dropdown" aria-expanded="false">
              {{examList.find((c) => c._id === Obj.examID)?.Name || ""}}
            </button>

            <ul class="dropdown-menu w-100 scrollable-menu">
              <li v-for="(item, index) in examList" :key="index" :value="item.Name">
                <a class="dropdown-item" href="#" @click.prevent="Obj.examID = item._id">
                  {{ item.Name }}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md-3">
          <label class="form-label">Student:</label>
          <select v-model="Obj.studentID" class="form-select form-select-sm rounded cursor-pointer" role="button">
            <option selected=""></option>
            <option v-for="(item, index) in drpList" :key="index" :value="item._id">
              {{ item.firstName }} {{ item.lastName }}
            </option>
          </select>
        </div>
        <div class="col-md-12 text-end mt-2">
          <button class="btn btn-sm btn-success me-1" @click="goClicked">
            <i class="fa fa-search text-white me-1"></i>Go
          </button>
          <button type="button" class="btn btn-sm btn-soft-dark" @click="reset()">
            <i class="fa fa-times-circle me-1"></i> Clear
          </button>
        </div>
      </div>
      <ul v-if="errors.length" class="text-danger ps-3">
        <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
      </ul>
      <div class="row g-3 mt-2 flex-nowrap" v-if="formReady">
        <div class="col-auto">
          <label class="form-label">Class:
            <span class="text-info">
              {{
                clsList.find((cls) => cls._id == appliedFilters.clsID)?.name ||
                ""
              }}
            </span>
          </label>
        </div>
        <div class="col-auto">
          <label class="form-label">Section:
            <span class="text-success">
              {{
                secList.find((sec) => sec._id == appliedFilters.sectionID)
                  ?.Name || ""
              }}
            </span>
          </label>
        </div>
        <div class="col-auto">
          <label class="form-label">Exam Type:
            <span class="text-danger">
              {{
                examList.find((sec) => sec._id == appliedFilters.examID)
                  ?.Name || ""
              }}
            </span>
          </label>
        </div>
      </div>
      <div v-if="
        progress == 0 &&
        formReady &&
        filteredMarkList.length === 0 &&
        List1.length === 0
      " class="text-start py-4 fw-bold">
        No Records...
      </div>
      <div class="row" v-if="(formReady && filteredMarkList.length > 0) || List1.length > 0">
        <div class="col-md-12 text-end">
          <a class="text-primary me-1 text-decoration-underline cursor-pointer" role="button" data-bs-toggle="modal"
            data-bs-target="#MarksReport">
            View All
          </a>
        </div>
        <div class="col-md-12 table-responsive marks-table-wrapper">
          <div class="progress mb-0 progress-sm" v-if="progress != 0">
            <div class="progress-bar" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"
              :style="{ width: progress + '%' }"></div>
          </div>
          <table class="table table-bordered custom-table" v-if="progress == 0 && filteredSubjects.length > 0">
            <thead>
              <tr>
                <th>RollNo</th>
                <th class="text-nowrap">Student Name</th>
                <th v-for="sub in filteredSubjects" :key="sub._id">
                  {{ sub.name }}
                </th>
                <th>Remarks</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in filteredMarkList" :key="index">
                <td>
                  {{
                    drpList.find((stu) => stu._id === item.studentID)?.rollNo ||
                    ""
                  }}
                </td>
                <td>
                  {{
                    drpList.find((stu) => stu._id === item.studentID)
                      ?.firstName || ""
                  }}
                  {{
                    drpList.find((stu) => stu._id === item.studentID)
                      ?.lastName || ""
                  }}
                </td>
                <td v-for="sub in filteredSubjects" :key="sub._id">
                  {{
                    item.subMarks?.[0]?.[sub.name]?.value != null
                      ? Number(item.subMarks?.[0]?.[sub.name]?.value).toFixed(2).replace(/\.?0+$/, "")
                      : ""
                  }}
                  <span v-if="isParticipationEditing(item, sub.name)" style="margin-left: 3em">
                    <button type="button" class="btn btn-link btn-sm p-0" title="Save participation marks"
                      aria-label="Save participation marks" :disabled="participationSavingKey ===
                        participationEditKey(item, sub.name)
                        " @click.stop="saveParticipation(item, sub.name)">
                      <i class="fa fa-save text-success fs-5"></i>
                    </button>
                    <button type="button" class="btn btn-link btn-sm p-0" title="Cancel editing"
                      aria-label="Cancel editing" @click.stop="cancelParticipationEdit(item, sub.name)">
                      <i class="fa fa-times text-muted fs-5"></i>
                    </button>
                  </span>
                  <span v-if="Object.keys(item.subMarks[0][Object.keys(item.subMarks[0])[0]]).some(key =>
                    key.endsWith(' _preSum'))" style="margin-left: 3em">
                    <button type="button" class="btn btn-link btn-sm p-0 ms-1" title="Edit participation marks"
                      aria-label="Edit participation marks" @click.stop="startParticipationEdit(item, sub.name)">
                      <i class="fa fa-edit text-primary fs-5"></i>
                    </button>
                  </span>
                  <br />
                  <div v-if="isParticipationEditing(item, sub.name)" class="d-flex flex-wrap align-items-center gap-1">
                    <label v-for="([key], index) in Object.entries(
                      participationDrafts[
                      participationEditKey(item, sub.name)
                      ],
                    )" :key="key" class="d-inline-flex align-items-center gap-1 mb-0">
                      <span>{{
                        key
                          .split(" ")
                          .map((word) => word[0])
                          .join(" ")
                      }}:</span>
                      <input v-model.number="participationDrafts[
                        participationEditKey(item, sub.name)
                      ][key]
                        " type="number" class="form-control form-control-sm participation-edit-input no-spin"
                        :aria-label="`${sub.name} ${key} marks`" />
                      <span v-if="
                        index <
                        Object.keys(
                          participationDrafts[
                          participationEditKey(item, sub.name)
                          ],
                        ).length -
                        1
                      ">,</span>
                    </label>
                  </div>
                  <div v-else>
                    <span v-for="([key, value], index) in Object.entries(
                      item.subMarks?.[0]?.[sub.name]?.participation || {},
                    ).filter(([k]) => k !== 'v')" :key="key">
                      {{
                        key
                          .split(" ")
                          .map((word) => word[0])
                          .join(" ")
                      }}
                      : {{ value }}
                      <span v-if="
                        index <
                        Object.entries(
                          item.subMarks?.[0]?.[sub.name]?.participation || {},
                        ).filter(([k]) => k !== 'v').length -
                        1
                      ">,
                      </span>
                    </span>
                  </div>
                </td>
                <td>{{ item.remarks }}</td>
                <td class="text-nowrap">
                  <span class="text-primary cursor-pointer" role="button" data-bs-toggle="modal"
                    data-bs-target="#AttendanceModal" @click="prepareAttendanceModal(item)">
                    <i class="fa fa-calendar-check fs-5 me-1 mt-2 text-primary cursor-pointer"></i>
                  </span>
                  <span role="button" @click="openAssessmentPopup(item)">
                    <i class="fa fa-file-circle-plus fs-5 me-1 mt-2 text-primary cursor-pointer"></i>
                  </span>
                  <i class="fa fa-download text-dark fs-5 me-1 cursor-pointer" role="button"
                    @click="prepareModal(item, 'download')">
                  </i>
                  <i class="fa fa-print text-primary fs-5 cursor-pointer me-1" role="button"
                    @click="prepareModal(item, 'print')">
                  </i>
                  <i class="fa fa-trash text-danger fs-5 cursor-pointer" role="button" data-bs-toggle="modal"
                    data-bs-target="#standard-modal" @click="delID = item">
                  </i>
                </td>
              </tr>
              <template v-if="List1.length">
                <tr v-for="(item, index) in List1" :key="index">
                  <td>{{ item.rollNo }}</td>
                  <td>{{ item.firstName }} {{ item.lastName }}</td>
                  <td v-for="sub in filteredSubjects" :key="sub._id">
                    <input type="number" class="form-control form-control-sm" v-model="item[sub.name]" />
                    <template v-if="examList.find((ex) => ex._id === appliedFilters.examID).sum">
                      <span>
                        {{ getExamShortName(appliedFilters.examID, 'selExType1') }} + {{
                          getExamShortName(appliedFilters.examID, 'selExType2') }}
                      </span>
                      <input type="text" class="form-control form-control-sm"
                        v-model="item[sub.name + '_' + 'preSum']" />
                    </template>
                    <template v-if="
                      examList.find((ex) => ex._id === appliedFilters.examID)
                        ?.Participation.length
                    ">
                      <div class="d-flex flex-wrap gap-1 mt-1 participation-container">
                        <div v-for="part in examList.find(
                          (ex) => ex._id === appliedFilters.examID,
                        )?.Participation" :key="`${sub.name}-${part}`"
                          class="d-flex flex-column align-items-start gap-1 participation-item">
                          <label class="form-label small mb-0">{{
                            part
                              .split(" ")
                              .map((word) => word.charAt(0))
                              .join("")
                          }}</label>
                          <input type="text" class="form-control form-control-sm participation-input" v-model.number="item[getParticipationInputKey(sub.name, part)]
                            " @input="updateParticipationTotal(item, sub.name)" />
                        </div>
                      </div>
                    </template>
                  </td>

                  <td>
                    <textarea type="text" class="form-control form-control-sm" v-model="item.remarks" rows="7">
  </textarea>
                  </td>
                  <td>
                    <span class="text-primary cursor-pointer" role="button" data-bs-toggle="modal"
                      data-bs-target="#AttendanceModal" @click="prepareAttendanceModal(item)">
                      <i class="fa fa-calendar-check fs-4 me-1 mt-2 text-primary cursor-pointer"></i>
                    </span>
                    <span role="button" @click="openAssessmentPopup(item)">
                      <i class="fa fa-file-circle-plus fs-5 me-1 mt-2 text-primary cursor-pointer"></i>
                    </span>
                    <i class="fa fa-save fs-4 mt-2 text-primary cursor-pointer" role="button" @click="save(index)"></i>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="MarksReport" tabindex="-1" aria-labelledby="MarksReport" aria-hidden="true"
    data-bs-backdrop="static" data-bs-keyboard="false" style="background-color: rgb(12 12 12 / 50%)">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="text-primary">
            {{
              examList.find((sec) => sec._id == appliedFilters.examID)?.Name ||
              ""
            }}
            Marks Report for
            {{
              clsList.find((cls) => cls._id == appliedFilters.clsID)?.name || ""
            }}
            ({{
              secList.find((sec) => sec._id == appliedFilters.sectionID)
                ?.Name || ""
            }})
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="col-md-12 table-responsive">
            <table class="table table-bordered custom-table">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Roll No</th>
                  <th class="text-nowrap">Student Name</th>
                  <th v-for="sub in filteredSubjects" :key="sub._id">
                    {{ sub.name }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in filteredMarkList" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>
                    {{
                      drpList.find((stu) => stu._id === item.studentID)
                        ?.rollNo || ""
                    }}
                  </td>
                  <td>
                    {{
                      drpList.find((stu) => stu._id === item.studentID)
                        ?.firstName || ""
                    }}
                    {{
                      drpList.find((stu) => stu._id === item.studentID)
                        ?.lastName || ""
                    }}
                  </td>
                  <td v-for="sub in filteredSubjects" :key="sub._id">
                    {{ item.subMarks?.[0]?.[sub.name]?.value ?? "" }}
                    <br />
                    <span v-for="([key, value], index) in Object.entries(
                      item.subMarks?.[0]?.[sub.name]?.participation || {},
                    ).filter(([k]) => k !== 'v')" :key="key">
                      {{
                        key
                          .split(" ")
                          .map((word) => word[0])
                          .join(" ")
                      }}
                      : {{ value }}
                      <span v-if="
                        index <
                        Object.entries(
                          item.subMarks?.[0]?.[sub.name]?.participation || {},
                        ).filter(([k]) => k !== 'v').length -
                        1
                      ">,
                      </span>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div ref="modalContent" class="invisible-content">
    <div class="card w-95 ms-1">
      <div class="card-body">
        <div>
          <div style="text-align: center; display: flex; justify-content: center">
            <div style="float: left">
              <img :src="getUrl(profile && profile.Image)" alt="School Logo" style="width: 70px; height: 70px" />
            </div>
            <div style="width: 80%">
              <strong> {{ profile && profile.Name }}</strong> <br /><span>{{
                profile && profile.Address
              }}</span>
              <br /><span>{{ profile && profile.Email }}</span> <br /><span>{{
                profile && profile.MobileNo
              }}</span>
            </div>
            <!-- <div>
              <img
                :src="
                  getUrl(
                    drpList.find((stu) => stu._id === selectedRecord?.studentID)
                      ?.image,
                  )
                "
                alt="Student Photo"
                class="me-2 mb-3 avatar-xl stuPhoto"
              />
            </div> -->
          </div>
          <!--       <hr /> -->
          <h6 class="text-center bg-secondary p-2 m-0 rounded border-box hd-margin">
            Result Card of
            {{
              examList.find((ex) => ex._id === selectedRecord?.examID)?.Name ||
              ""
            }}
            exam {{ currentyear }}
          </h6>
          <div class="col-md-12 d-flex justify-content-between mb-0">
            <div class="profileInfo">
              <strong>Student Name:</strong>
              {{
                drpList.find((stu) => stu._id === selectedRecord?.studentID)
                  ?.firstName || ""
              }}
              {{
                drpList.find((stu) => stu._id === selectedRecord?.studentID)
                  ?.lastName || ""
              }}
              <br />
              <strong> Father Name:</strong>
              {{
                drpList.find((stu) => stu._id === selectedRecord?.studentID)
                  ?.parent.fatherName || ""
              }}
            </div>
            <div class="profileInfo">
              <strong>Admission NO:</strong>
              {{
                drpList.find((stu) => stu._id === selectedRecord?.studentID)
                  ?.admissionNumber || ""
              }}
              <br />
              <strong>Roll No:</strong>
              {{
                drpList.find((stu) => stu._id === selectedRecord?.studentID)
                  ?.rollNo || ""
              }}
            </div>

            <div class="profileInfo">
              <strong>Class:</strong>
              {{
                clsList.find((cls) => cls._id === selectedRecord?.clsID)
                  ?.name || ""
              }}
              ({{
                secList.find((sec) => sec._id === selectedRecord?.sectionID)
                  ?.Name || ""
              }})
              <br />
              <strong>Date:</strong> {{ formattedCurrentDate }}
            </div>

            <div class="col-md-2"></div>
          </div>
          <div class="border border-light">

            <template v-if="!examList.find((ex) => ex._id === appliedFilters.examID)?.sum">
              <table class="table table-bordered border text-center">
                <thead>
                  <tr class="bg-gray-200 text-center">
                    <th>
                      <div class="vertical-cell">
                        <span class="vertical-word"> S.No </span>
                      </div>
                    </th>
                    <th>Subject</th>
                    <template v-if="
                      selectedRecord.subMarks?.length &&
                      Object.values(selectedRecord.subMarks[0]).length
                    ">
                      <th v-for="key in Object.keys(
                        Object.values(selectedRecord.subMarks?.[0] || {})[0]
                          ?.participation || {},
                      )" :key="key">
                        <div class="vertical-cell">
                          <template v-if="key.includes(' ')">
                            <span v-for="word in key.split(' ')" :key="word" class="vertical-word">
                              {{ word }}
                            </span>
                          </template>
                          <template v-if="!key.includes(' ')">
                            <span class="vertical-word">
                              {{ key }}
                            </span>
                          </template>
                        </div>
                      </th>
                    </template>

                    <th v-if="examList.find((ex) => ex._id === appliedFilters.examID)?.sum">
                      {{ getExamShortName(appliedFilters.examID, 'selExType1') }} + {{
                        getExamShortName(appliedFilters.examID,
                          'selExType2') }}
                    </th>
                    <th>
                      <div class="vertical-cell">
                        <span class="vertical-word"> Obatined</span>
                        <span class="vertical-word"> Marks</span>
                      </div>
                    </th>
                    <th>
                      <div class="vertical-cell">
                        <span class="vertical-word"> Total</span>
                        <span class="vertical-word"> Marks</span>
                      </div>
                    </th>
                    <th>
                      <div class="vertical-cell">
                        <span class="vertical-word"> Grade</span>
                      </div>
                    </th>
                    <th>
                      <div class="vertical-cell">
                        <span class="vertical-word"> Remark</span>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(mark, subject) in selectedMarks" :key="subject">
                    <td>{{ Object.keys(selectedMarks).indexOf(subject) + 1 }}</td>
                    <td>
                      {{ subject }}
                    </td>
                    <td v-for="(entry, index) in Object.entries(
                      mark?.participation || {},
                    )" :key="index">
                      {{ entry[1] }}
                    </td>

                    <td v-if="examList.find((ex) => ex._id === appliedFilters.examID)?.sum">
                      {{ selectedRecord.subMarks[0]?.[subject]?.[`${subject}_preSum`] }}
                    </td>
                    <td>
                      {{
                        mark?.value != null
                          ? Number(mark.value).toFixed(2).replace(/\.?0+$/, "")
                          : ""
                      }}
                      <span :class="Number(mark?.value ?? 0) >=
                        (getSubjectSetup(subject)?.passMark ?? 0)
                        ? 'text-success'
                        : 'text-danger'
                        ">
                        {{
                          Number(mark?.value ?? 0) >=
                            (getSubjectSetup(subject)?.passMark ?? 0)
                            ? "P"
                            : "F"
                        }}
                      </span>
                    </td>
                    <td>{{ getSubjectSetup(subject)?.totalMarks ?? "" }}</td>

                    <td>{{ getGrade(mark, subject) }}</td>
                    <td>{{ getRemark(mark, subject) }}</td>
                  </tr>
                </tbody>
              </table>
              <div class="d-flex justify-content-between align-items-center mb-2 mt-2">
                <div>
                  <small><strong>GRAND TOTAL:</strong>
                    {{ obtainedMarks.toFixed(1) }}/{{ totalMarks }}</small>
                </div>
                <div>
                  <small><strong>PERCENTAGE:</strong> {{ percentage }}%</small>
                </div>
                <div style="margin: 5px">
                  <small><strong>RESULT:</strong> {{ result }}</small>
                </div>
              </div>
              <div style="height: 50px">
                <strong>Remarks:</strong>
                {{
                  selectedRecord.remarks
                    ? selectedRecord.remarks
                    : overAllGrade(obtainedMarks)?.Remarks || ""
                }}
              </div>
            </template>

            <template v-if="examList.find((ex) => ex._id === appliedFilters.examID)?.sum">
              <table class="table table-bordered border text-center">
                <thead>
                  <tr class="bg-gray-200 text-center">
                    <th>
                      S.No
                    </th>
                    <th>Subject</th>
                    <template v-if="
                      selectedRecord.subMarks?.length &&
                      Object.values(selectedRecord.subMarks[0]).length
                    ">
                      <th v-for="key in Object.keys(
                        Object.values(selectedRecord.subMarks?.[0] || {})[0]
                          ?.participation || {},
                      )" :key="key">
                        <template v-if="key.includes(' ')">
                          <span v-for="word in key.split(' ')" :key="word">
                            {{ word }}
                          </span>
                        </template>
                        <template v-if="!key.includes(' ')">
                          <span>
                            {{ key }}
                          </span>
                        </template>
                      </th>
                    </template>

                    <th>
                      AVG-FA'S
                      <br />
                      (20M)
                    </th>
                    <th>
                      SA-1 <br /> (80M)
                    </th>
                    <th>
                      Total Marks
                      <br />
                      (100M)
                    </th>
                    <th>
                      Grade
                    </th>

                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(mark, subject) in selectedMarks" :key="subject">
                    <td>{{ Object.keys(selectedMarks).indexOf(subject) + 1 }}</td>
                    <td>
                      {{ subject }}
                    </td>
                    <td v-for="(entry, index) in Object.entries(
                      mark?.participation || {},
                    )" :key="index">
                      {{ entry[1] }}
                    </td>

                    <td v-if="examList.find((ex) => ex._id === appliedFilters.examID)?.sum">
                      {{ selectedRecord.subMarks[0]?.[subject]?.[`${subject}_preSum`] }}
                    </td>
                    <td>
                      {{
                        mark?.value != null
                          ? Number(mark.value).toFixed(2).replace(/\.?0+$/, "")
                          : ""
                      }}

                    </td>
                    <td>
                      {{
                        Number(selectedRecord.subMarks[0]?.[subject]?.[`${subject}_preSum`] || 0) +
                        Number(Number(mark.value).toFixed(2).replace(/\.?0+$/, ""))
                      }}
                    </td>

                    <td>{{ getGrade(mark, subject) }}</td>
                  </tr>
                </tbody>
              </table>
              <div class="d-flex justify-content-between align-items-center mb-2 mt-2">
                <div>
                  <small><strong>GRAND TOTAL:</strong>
                    {{(Object.values(selectedRecord?.subMarks?.[0] || {})
                      .reduce((sum, subject) => sum + Number(subject[Object.keys(subject).find(key =>
                        key.includes('_preSum'))]
                        || 0), 0)
                      +
                      obtainedMarks).toFixed(1)
                    }}/{{ totalMarks }}</small>
                </div>
                <div>
                  <small><strong>PERCENTAGE:</strong> {{ percentage }}%</small>
                </div>
                <!--<div style="margin: 5px">
                  <small><strong>RESULT:</strong> {{ result }}</small>
                </div> -->
              </div>
              <div style="height: 50px">
                <br />
                <strong>Remarks:</strong>
                {{
                  selectedRecord.remarks
                    ? selectedRecord.remarks
                    : overAllGrade(obtainedMarks)?.Remarks || ""
                }}
              </div>
            </template>

            <div>
              <br />
              <strong style="display: block">Attendance :</strong>
              <table border="1" cellpadding="8" cellspacing="0" style="margin: 0rem">
                <thead>
                  <tr>
                    <th>Month</th>
                    <th v-for="month in attendanceRecord.months" :key="month.name">
                      {{ month.name }} <br />
                      ({{ month.workingDays }})
                    </th>
                    <th>
                      Total <br />
                      ({{
                        attendanceRecord.months.reduce(
                          (total, month) => total + month.workingDays,
                          0,
                        )
                      }})
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Days</td>
                    <td v-for="month in attendanceRecord.months" :key="month.name">
                      {{ month.presentDays }}
                    </td>
                    <td>
                      {{
                        attendanceRecord.months.reduce(
                          (total, month) => total + month.presentDays,
                          0,
                        )
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-if="selectedRecord.assessment?.comprehensive.length > 0">
              {{ selectedRecord.assessment.comprehensive }}
            </div>
            <div v-if="selectedRecord.assessment?.coCurricular.length > 0">
              <table border="1" class="custom-table fs-6">
                <thead>
                  <tr>
                    <th>CO-CURRICULAR ACTIVITIES</th>
                    <th>MARKS</th>
                    <th>CO-CURRICULAR SUBJECTS</th>
                    <th>MARKS</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Value Education &amp; Life Skills (50M)</td>
                    <td>
                      {{ Curricular(selectedRecord.assessment.coCurricular, "Value Education & Life Skills (50M)",
                        "activity")
                      }}
                    </td>
                    <td>Computer Education (50M / 100M)</td>
                    <td> {{ Curricular(selectedRecord.assessment.coCurricular, "Computer Education (50M / 100M)",
                      "subject")
                    }}
                    </td>
                  </tr>
                  <tr>
                    <td>Arts &amp; Cultural Education (50M)</td>
                    <td>{{ Curricular(selectedRecord.assessment.coCurricular, "Arts & Cultural Education (50M)",
                      "activity")
                    }}
                    </td>
                    <template v-if="Curricular(selectedRecord.assessment.coCurricular, 'GK (50M)', 'subject') !== ''">
                      <td>GK (50M)</td>
                      <td>{{ Curricular(selectedRecord.assessment.coCurricular, 'GK (50M)', 'subject') }}</td>
                    </template>
                    <template
                      v-if="Curricular(selectedRecord.assessment.coCurricular, 'Vedic math’s (50M / 100M)', 'subject') !== ''">
                      <td>Vedic math’s (50M / 100M)</td>
                      <td>{{ Curricular(selectedRecord.assessment.coCurricular, 'Vedic math’s (50M / 100M)', 'subject')
                      }}</td>
                    </template>
                    <template
                      v-if="Curricular(selectedRecord.assessment.coCurricular, 'Vedic math’s  (50M / 100M)', 'subject') == '' && Curricular(selectedRecord.assessment.coCurricular, 'GK', 'subject') == ''">
                      <td></td>
                      <td></td>
                    </template>
                  </tr>
                  <tr>
                    <td>Health &amp; Physical Education (50M)</td>
                    <td> {{ Curricular(selectedRecord.assessment.coCurricular, "Health & Physical Education (50M)",
                      "activity") }}
                    </td>
                    <td>
                      {{ Curricular(selectedRecord.assessment.coCurricular, 'Communication (50M)', 'subject') !== '' ?
                        'Communication (50M)' : '' }}
                    </td>
                    <td>
                      {{
                        Curricular(selectedRecord.assessment.coCurricular, 'Communication (50M)', 'subject') !== ''
                          ? Curricular(selectedRecord.assessment.coCurricular, "Communication (50M)", "subject") : '' }}
                    </td>
                  </tr>
                  <tr v-if="Curricular(selectedRecord.assessment.coCurricular, 'Abacus (50M)', 'subject') !== ''">
                    <td></td>
                    <td></td>
                    <td>Abacus (50M)
                    </td>
                    <td>
                      {{ Curricular(selectedRecord.assessment.coCurricular, "Abacus (50M)", "subject") }} </td>
                  </tr>
                  <tr>
                    <td>Total Grade</td>
                    <td> {{ Curricular(selectedRecord.assessment.coCurricular, "Total Grade",
                      "activity") }} </td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- <div>
              <table>
                <thead>
                  <tr>
                    <th>COMPREHENSIVE FEEDBACK</th>
                    <th>A</th>
                    <th>B</th>
                    <th>C</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>READING SKILLS</td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>COMMUNICATION SKILLS</td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>READING OF LANGUAGES</td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>NEATNESS OF UNIFORM</td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>CLASSROOM INTERACTION</td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div> -->
            <div class="d-flex justify-content-between align-items-center"
              style="margin-top: 4.5rem; margin-bottom: 0.1rem">
              <div>
                <small>Class Teacher </small>
              </div>
              <div>
                <small>Principal </small>
              </div>
              <div>
                <small>Parent </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="AttendanceModal" tabindex="-1" aria-labelledby="AttendanceModalLabel" aria-hidden="true"
    data-bs-backdrop="static" data-bs-keyboard="false" style="background-color: rgb(12 12 12 / 50%)">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content ps-2">
        <div class="modal-header">
          <h5 class="modal-title text-primary" id="AttendanceModalLabel">
            {{
              drpList.find((stu) => stu._id === attendanceRecord.studentID)
                ?.firstName || ""
            }}
            {{
              drpList.find((stu) => stu._id === attendanceRecord.studentID)
                ?.lastName || ""
            }}
            Attendance
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row g-3 mb-3">
            <div class="col-md-5">
              <label class="form-label"><strong> Student Name:</strong></label>
              {{
                drpList.find((stu) => stu._id === attendanceRecord.studentID)
                  ?.firstName || ""
              }}
              {{
                drpList.find((stu) => stu._id === attendanceRecord.studentID)
                  ?.lastName || ""
              }}
            </div>
            <div class="col-md-3">
              <label class="form-label"><strong>Class:</strong></label>
              {{ attendanceRecord.className }}
            </div>
            <div class="col-md-3">
              <label class="form-label"><strong>Roll No:</strong></label>
              {{
                drpList.find((stu) => stu._id === attendanceRecord.studentID)
                  ?.rollNo || ""
              }}
            </div>
          </div>
          <div class="table-responsive col-md-5">
            <table class="table table-bordered align-middle mark-static">
              <thead>
                <tr>
                  <th>Month</th>
                  <th class="text-center">Working Days</th>
                  <th class="text-center">Present Days</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(month, index) in attendanceRecord.months" :key="month.name">
                  <td>{{ month.name }}</td>
                  <td>
                    <input type="number" class="form-control form-control-sm" min="0" v-model.number="attendanceRecord.months[index].workingDays
                      " />
                  </td>
                  <td>
                    <input type="number" class="form-control form-control-sm" min="0" v-model.number="attendanceRecord.months[index].presentDays
                      " />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-soft-dark" data-bs-dismiss="modal">
            Close
          </button>
          <button type="button" class="btn btn-sm btn-primary" @click="saveAttendance">
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="assessmentPopup.show" class="modal fade show d-block" tabindex="-1" role="dialog" aria-modal="true"
    style="background-color: rgb(12 12 12 / 50%)">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-primary">

            Assessment Details - {{ assessmentPopup.studentName }}
          </h5>
          <button type="button" class="btn-close" aria-label="Close" @click="closeAssessmentPopup"></button>
        </div>
        <div class="modal-body">
          <div class="row g-3">
            <div class="col-md-12" v-if="examList.find((ex) => ex._id === Obj.examID)?.tblType === 'COMPREHENSIVE'">
              <table border="1" class="custom-table fs-6 w-100">
                <thead>
                  <tr>
                    <th>COMPREHENSIVE FEEDBACK</th>
                    <th>A</th>
                    <th>B</th>
                    <th>C</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in comprehensiveRows" :key="index">
                    <td>{{ row.label }}</td>
                    <td><input type="text" class="form-control form-control-sm" v-model="row.a" /></td>
                    <td><input type="text" class="form-control form-control-sm" v-model="row.b" /></td>
                    <td><input type="text" class="form-control form-control-sm" v-model="row.c" /></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-12" v-if="examList.find((ex) => ex._id === Obj.examID)?.tblType === 'CO-CURRICULAR'">
              <table border="1" class="custom-table fs-6 w-100">
                <thead>
                  <tr>
                    <th>CO-CURRICULAR ACTIVITIES</th>
                    <th style="width:10%">MARKS</th>
                    <th>CO-CURRICULAR SUBJECTS</th>
                    <th style="width:10%">MARKS</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in coCurricularRows" :key="index">
                    <td>{{ row.activity || "" }}</td>
                    <td>
                      <input v-if="row.activity" type="text" class="form-control form-control-sm" v-model="row.marks" />
                    </td>
                    <td>{{ row.subject || "" }}</td>
                    <td>
                      <input v-if="row.subject" type="text" class="form-control form-control-sm"
                        v-model="row.subjectMarks" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-primary me-2" @click="saveAssessmentPopup">Save</button>
          <button type="button" class="btn btn-sm btn-soft-dark" @click="closeAssessmentPopup">Close</button>
        </div>
      </div>
    </div>
  </div>
  <DelPopup :name="clsList.find((cls) => cls._id == delID.clsID)?.name" @delRecord="delRecord"
    @closeModal="delID = {}" />
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import DelPopup from "@/components/Common/DelPopup.vue";
import { isRequired, validateForm } from "@/utils/validation.js";
import { api } from "@/utils/helpers.js";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { ref, onMounted, computed, nextTick } from "vue";
import { schoolStore } from "@/utils/schoolStore";
const { clsList, uniqueClsList, secList, examList, subList, profile } =
  schoolStore();
const examSetupList = ref([]);
const modalContent = ref(null);
const Obj = ref({ clsID: "", sectionID: "", examID: "", studentID: "" });
const appliedFilters = ref({
  clsID: "",
  sectionID: "",
  examID: "",
  studentID: "",
});
const subMarks = ref({ RollNo: "", student: "" });
const List = ref([]);
const markList = ref([]);
const filteredMarkList = ref([]);
const List1 = ref([]);
const drpList = ref([]);
const gradeList = ref([]);
const msgObj = ref({ msg: "", role: "", show: false });
const delID = ref({});
const popUpData = ref({})
const participationDrafts = ref({});
const activeParticipationEditKey = ref("");
const participationSavingKey = ref("");
const errors = ref({});
const formReady = ref(false);
const selectedRecord = ref({});
const assessmentPopup = ref({
  show: false,
  studentName: "",
  item: null,
});
const getDefaultComprehensiveRows = () => [
  { label: "READING SKILLS", a: "", b: "", c: "" },
  { label: "COMMUNICATION SKILLS", a: "", b: "", c: "" },
  { label: "READING OF LANGUAGES", a: "", b: "", c: "" },
  { label: "NEATNESS OF UNIFORM", a: "", b: "", c: "" },
  { label: "CLASSROOM INTERACTION", a: "", b: "", c: "" },
];
const getDefaultCoCurricularRows = () => [
  { activity: "Value Education & Life Skills (50M)", marks: "", subject: "Computer Education (50M / 100M)", subjectMarks: "" },
  { activity: "Arts & Cultural Education (50M)", marks: "", subject: "GK (50M)", subjectMarks: "" },
  { activity: "", marks: "", subject: "Vedic math's (50M / 100M)", subjectMarks: "" },
  { activity: "Health & Physical Education (50M)", marks: "", subject: "Communication (50M)", subjectMarks: "" },
  { activity: "", marks: "", subject: "Abacus (50M)", subjectMarks: "" },
  { activity: "Total Grade", marks: "", subject: "", subjectMarks: "" },
];
const comprehensiveRows = ref(getDefaultComprehensiveRows());
const coCurricularRows = ref(getDefaultCoCurricularRows());
const openAssessmentPopup = (item) => {
  popUpData.value = {}
  const student = drpList.value.find((stu) => stu._id === item.studentID);
  const savedAssessment = item.assessment || {};
  const savedComprehensive = Array.isArray(savedAssessment.comprehensive)
    ? savedAssessment.comprehensive
    : getDefaultComprehensiveRows();
  const savedCoCurricular = Array.isArray(savedAssessment.coCurricular)
    ? savedAssessment.coCurricular
    : getDefaultCoCurricularRows();

  comprehensiveRows.value = savedComprehensive.map((row) => ({
    label: row.label || "",
    a: row.a ?? "",
    b: row.b ?? "",
    c: row.c ?? "",
  }));
  coCurricularRows.value = savedCoCurricular.map((row) => ({
    activity: row.activity || "",
    marks: row.marks ?? "",
    subject: row.subject || "",
    subjectMarks: row.subjectMarks ?? "",
  }));

  assessmentPopup.value = {
    show: true,
    studentName: student ? `${student.firstName || ""} ${student.lastName || ""}`.trim() : "Student",
    item,
  };
};
const closeAssessmentPopup = () => {
  assessmentPopup.value = {
    show: false,
    studentName: "",
    item: null,
  };
};

const getExamShortName = (examID, examType) => {
  if (examID && examType) {
    const id = examList.value.find(e => e._id === examID)?.[examType];
    const name = examList.value.find(e => e._id === id)?.Name;
    return name ? name.split(' - ')[0].split(' ').map(w => w[0]).join('') + (name.split(' - ')[1] || '') : '';
  } else {
    return '';
  }
}
const saveAssessmentPopup = async () => {
  const record = assessmentPopup.value.item;
  if (!record || !record._id) return;

  const hasAnyComprehensiveValue = (row) =>
    [row.a, row.b, row.c].some((value) => value !== null && value !== undefined && String(value).trim() !== "");

  const hasAnyCoCurricularValue = (row) =>
    [row.activity, row.marks, row.subject, row.subjectMarks].some(
      (value) => value !== null && value !== undefined && String(value).trim() !== "",
    );

  const updatedRecord = {
    ...record,
    assessment: {
      comprehensive: comprehensiveRows.value
        .filter(hasAnyComprehensiveValue)
        .map((row) => ({
          label: row.label,
          a: row.a,
          b: row.b,
          c: row.c,
        })),
      coCurricular: coCurricularRows.value
        .filter(hasAnyCoCurricularValue)
        .map((row) => ({
          activity: row.activity,
          marks: row.marks,
          subject: row.subject,
          subjectMarks: row.subjectMarks,
        })),
    },
  };

  delete updatedRecord.__v;

  try {

    if (record.subMarks && record.subMarks.length > 0) {
      await api.put(`/marks/${record._id}`, updatedRecord);
      record.assessment = updatedRecord.assessment;
      const index = filteredMarkList.value.findIndex((item) => item._id === record._id);
      if (index >= 0) {
        filteredMarkList.value[index].assessment = updatedRecord.assessment;
      }
    } else {
      popUpData.value = updatedRecord.assessment;
    }

    msgObj.value = {
      msg: "Assessment details saved successfully.",
      role: "success",
      show: true,
    };
    closeAssessmentPopup();
  } catch (error) {
    console.error("Failed to save assessment details:", error);
    msgObj.value = {
      msg: error.response?.data?.message || "Failed to save assessment details.",
      role: "danger",
      show: true,
    };
  }
};
const attendanceRecord = ref({
  studentName: "",
  className: "",
  rollNo: "",
  clsID: "",
  sectionID: "",
  studentID: "",
  months: [
    { name: "Jan", workingDays: 0, presentDays: 0 },
    { name: "Feb", workingDays: 0, presentDays: 0 },
    { name: "Mar", workingDays: 0, presentDays: 0 },
    { name: "Apr", workingDays: 0, presentDays: 0 },
    { name: "May", workingDays: 0, presentDays: 0 },
    { name: "Jun", workingDays: 0, presentDays: 0 },
    { name: "Jul", workingDays: 0, presentDays: 0 },
    { name: "Aug", workingDays: 0, presentDays: 0 },
    { name: "Sep", workingDays: 0, presentDays: 0 },
    { name: "Oct", workingDays: 0, presentDays: 0 },
    { name: "Nov", workingDays: 0, presentDays: 0 },
    { name: "Dec", workingDays: 0, presentDays: 0 },
  ],
});
const currentyear = computed(() => {
  const today = new Date();
  const month = today.getMonth();
  const year = today.getFullYear();
  if (month >= 5) {
    return `${year}-${year + 1}`;
  } else {
    return `${year - 1}-${year}`;
  }
});
const loadGrades = async () => {
  const res = await api.get("/Grade/all");
  gradeList.value = res.data;
};

const filteredSubjects = computed(() => {
  if (!appliedFilters.value.clsID) return [];
  return subList.value.filter((s) => s.clsID === appliedFilters.value.clsID);
});
const getParticipationInputKey = (subjectName, participationName) => {
  return `${subjectName}__${participationName}`;
};
const participationEditKey = (item, subjectName) =>
  `${item._id}-${subjectName}`;
const isParticipationEditing = (item, subjectName) =>
  activeParticipationEditKey.value === participationEditKey(item, subjectName);
const startParticipationEdit = (item, subjectName) => {
  const editKey = participationEditKey(item, subjectName);
  const participation =
    item.subMarks?.[0]?.[subjectName]?.participation;
  const currentParticipation =
    participation && typeof participation === "object" && !Array.isArray(participation)
      ? participation
      : {};

  const configuredParticipation =
    examList.value.find((exam) => exam._id === appliedFilters.value.examID)
      ?.Participation || [];
  const participationNames = new Set([
    ...Object.keys(currentParticipation).filter((key) => key !== "v"),
    ...configuredParticipation,
  ]);

  participationDrafts.value[editKey] = Object.fromEntries(
    [...participationNames].map((name) => [
      name,
      currentParticipation[name]?.value ??
      currentParticipation[name]?.v ??
      currentParticipation[name] ??
      "",
    ]),
  );
  activeParticipationEditKey.value = editKey;
};
const cancelParticipationEdit = (item, subjectName) => {
  const editKey = participationEditKey(item, subjectName);
  delete participationDrafts.value[editKey];
  if (activeParticipationEditKey.value === editKey) {
    activeParticipationEditKey.value = "";
  }
};
const saveParticipation = async (item, subjectName) => {
  const editKey = participationEditKey(item, subjectName);
  const draft = participationDrafts.value[editKey];
  if (!draft || !item._id) return;

  const currentSubMarks = item.subMarks?.[0] || {};
  const currentSubjectMarks = currentSubMarks[subjectName] || {};
  const participation = {
    ...currentSubjectMarks.participation,
    ...draft,
  };
  const total = Object.values(draft).reduce(
    (sum, value) => sum + (Number(value) || 0),
    0,
  );
  const updatedRecord = {
    ...item,
    subMarks: [
      {
        ...currentSubMarks,
        [subjectName]: {
          ...currentSubjectMarks,
          value: total,
          participation,
        },
      },
    ],
  };
  delete updatedRecord.__v;

  participationSavingKey.value = editKey;
  try {
    await api.put(`/marks/${item._id}`, updatedRecord);
    item.subMarks = updatedRecord.subMarks;
    delete participationDrafts.value[editKey];
    if (activeParticipationEditKey.value === editKey) {
      activeParticipationEditKey.value = "";
    }
    msgObj.value = {
      msg: "Participation marks updated successfully.",
      role: "success",
      show: true,
    };
  } catch (error) {
    console.error("Failed to update participation marks:", error);
    msgObj.value = {
      msg:
        error.response?.data?.message ||
        "Failed to update participation marks.",
      role: "danger",
      show: true,
    };
  } finally {
    participationSavingKey.value = "";
  }
};
const prepareAttendanceModal = async (item) => {
  const className =
    clsList.value.find((cls) => cls._id === item.clsID)?.name || "";
  const sectionName =
    secList.value.find((sec) => sec._id === item.sectionID)?.Name || "";
  const defaultMonths = [
    { name: "Jun", workingDays: 0, presentDays: 0 },
    { name: "Jul", workingDays: 0, presentDays: 0 },
    { name: "Aug", workingDays: 0, presentDays: 0 },
    { name: "Sep", workingDays: 0, presentDays: 0 },
    { name: "Oct", workingDays: 0, presentDays: 0 },
    { name: "Nov", workingDays: 0, presentDays: 0 },
    { name: "Dec", workingDays: 0, presentDays: 0 },
    { name: "Jan", workingDays: 0, presentDays: 0 },
    { name: "Feb", workingDays: 0, presentDays: 0 },
    { name: "Mar", workingDays: 0, presentDays: 0 },
    { name: "Apr", workingDays: 0, presentDays: 0 },
    { name: "May", workingDays: 0, presentDays: 0 },
  ];

  attendanceRecord.value = {
    studentName: `${item.firstName || ""} ${item.lastName || ""}`.trim(),
    className: sectionName ? `${className} (${sectionName})` : className,
    rollNo: item.rollNo || item.studentID || "",
    clsID: item.clsID || "",
    sectionID: item.sectionID || "",
    studentID: item.studentID || item._id || "",
    months: defaultMonths,
  };

  const clsID = attendanceRecord.value.clsID;
  const sectionID = attendanceRecord.value.sectionID;
  const studentID = attendanceRecord.value.studentID;

  if (clsID && sectionID && studentID) {
    let attendanceData = null;
    try {
      const res = await api.get(
        `/staticattendance/find/${clsID}/${sectionID}/${studentID}`,
      );
      attendanceData = res.data;
    } catch (err) {
      attendanceData = null;
    }

    const monthsFromApi = attendanceData?.[0]?.months || [];

    if (Array.isArray(monthsFromApi) && monthsFromApi.length > 0) {
      attendanceRecord.value.months = defaultMonths.map((month) => {
        const matching = monthsFromApi.find(
          (m) => String(m.month).toLowerCase() === month.name.toLowerCase(),
        );
        return {
          name: month.name,
          workingDays: Number(matching?.workingDays || 0),
          presentDays: Number(matching?.presentDays || 0),
        };
      });
    }
  }
};
const saveAttendance = async () => {
  const invalidMonth = attendanceRecord.value.months.find(
    (month) => Number(month.presentDays) > Number(month.workingDays),
  );
  if (invalidMonth) {
    msgObj.value = {
      msg: `Present days cannot exceed working days for ${invalidMonth.name}.`,
      role: "danger",
      show: true,
    };
    return;
  }

  const payload = {
    studentID: attendanceRecord.value.studentID,
    clsID: attendanceRecord.value.clsID,
    sectionID: attendanceRecord.value.sectionID,
    rollNo: attendanceRecord.value.rollNo,
    studentName: attendanceRecord.value.studentName,
    months: attendanceRecord.value.months.map((month) => ({
      month: month.name,
      workingDays: Number(month.workingDays) || 0,
      presentDays: Number(month.presentDays) || 0,
    })),
  };

  try {
    await api.post("/staticattendance/add", payload);
    msgObj.value = {
      msg: "Attendance saved successfully.",
      role: "success",
      show: true,
    };
    const modalEl = document.getElementById("AttendanceModal");
    if (modalEl) {
      const bsModal = window.bootstrap?.Modal.getInstance(modalEl);
      if (bsModal) {
        bsModal.hide();
      } else {
        modalEl.classList.remove("show");
        modalEl.style.display = "none";
      }
    }
  } catch (error) {
    console.error(error);
    msgObj.value = {
      msg: error.response?.data?.message || "Failed to save attendance.",
      role: "danger",
      show: true,
    };
  }
};
const updateParticipationTotal = (student, subjectName) => {
  const exam = examList.value.find(
    (ex) => ex._id === appliedFilters.value.examID,
  );
  const participationItems = Array.isArray(exam?.Participation)
    ? exam.Participation.filter((item) => item && item.trim())
    : [];

  if (!participationItems.length) return;

  const total = participationItems.reduce((sum, part) => {
    const inputKey = getParticipationInputKey(subjectName, part);
    return sum + Number(student[inputKey] || 0);
  }, 0);

  student[subjectName] = total;
};
const loadExamSetup = async () => {
  try {
    const res = await api.get("/exmsetup/all");
    examSetupList.value = res.data;
  } catch (error) {
    console.error("Failed to fetch exam setup:", error);
  }
};
const getGrade = (mark, subject) => {
  const setup = getSubjectSetup(subject);
  if (!setup) return "-";

  const pass = Number(setup.passMark);
  const m = Number(mark.value);
  if (m < pass) return "F";
  const gradeItem = gradeList.value.find(
    (g) => {
      return Math.floor(Number(m)) >= g.MarksFrom &&
        Math.floor(Number(m)) <= g.MarksTo &&
        g.totMarks === setup.totalMarks &&
        g.examTypeID === selectedRecord.value.examID
    }
  );

  return gradeItem ? gradeItem.Grade : "-";
};

const getRemark = (mark, subject) => {
  const setup = getSubjectSetup(subject);
  if (!setup) return "-";

  const pass = Number(setup.passMark);
  const m = Math.floor(Number(mark.value));
  if (m < pass) return "F";
  const gradeItem = gradeList.value.find(
    (g) =>
      m >= Number(g.MarksFrom) &&
      m <= Number(g.MarksTo) &&
      g.totMarks === setup.totalMarks &&
      g.examTypeID === selectedRecord.value.examID,
  );

  return gradeItem ? gradeItem.Remarks : "-";
};

const overAllGrade = (total) => {
  const totalMarksValue = Number(total) || 0;
  if (!totalMarksValue || !selectedRecord.value?.examID) {
    return null;
  }
  const percentage = totalMarksValue / Object.keys(selectedMarks.value).length;

  const gradeItem = gradeList.value.find(
    (g) =>
      percentage >= Number(g.MarksFrom) &&
      percentage <= Number(g.MarksTo) &&
      g.examTypeID === selectedRecord.value.examID,
  );

  return gradeItem || null;
};

const print = async () => {
  const printWindow = window.open("", "", "width=900,height=700");
  if (!printWindow) return;

  await nextTick();
  const printElement = modalContent.value?.cloneNode(true);
  if (!printElement) {
    printWindow.close();
    return;
  }

  printElement.classList.remove("invisible-content");
  const images = printElement.querySelectorAll("img");
  await Promise.all(
    [...images].map(
      (img) =>
        new Promise((resolve) => {
          if (img.complete) resolve();
          else img.onload = img.onerror = resolve;
        }),
    ),
  );

  printWindow.document.write(`
    <html>
      <head>
        <style>
          body { font-family: 'Arial', sans-serif; padding: 10px; color: #000; }
          .card { width: 95%; margin: auto; }
          .d-flex { display: flex; } .align-items-start { align-items: flex-start; }
          .align-items-center { align-items: center; }
          .hd-margin {margin: 0.1rem;}
          .justify-content-between { justify-content: space-between; }
          .text-center { text-align: center; } .text-right { text-align: right; } .text-success{color: green;}
          .text-muted { color: #6c757d; } .text-danger{color: red;}
          .fw-bold { font-weight: bold; } .mb-0{margin-bottom:-10px;} .mb-3 { margin-bottom: 1rem; }
          h2{font-size:30px; margin-top:-10px; margin-left:5px; white-space: nowrap;}
          .mt-5{margin-top:5rem; margin-bottom:2rem;} .mt-2{margin-top:1rem;}
          img { width: 100px; height: 100px;}
          .stuPhoto { width: 60px; height: 60px;     border: 2px #ddd solid;      padding: 2px;   border-radius: 5px;}
          .profileInfo{margin-right: 1rem; display: inline; line-height: 24px;}
          .vertical-cell { letter-spacing: 1px; writing-mode: vertical-lr; text-orientation: mixed; white-space: nowrap; width: 35px; height: 100px; text-align: center; vertical-align: middle; }
          .vertical-word { display: block; writing-mode:  text-orientation: mixed; white-space: nowrap; font-size: 12px; line-height: 1.1; margin: 2px 0;  transform: rotate(180deg); }
          hr { margin: 1rem 0; border: none; border-top: 1px solid #ccc; }
          table { border-collapse: collapse; width: 100%; margin-top: 1rem; }
          th, td { border: 1px solid #aaa; padding: 8px; text-align: center; vertical-align: middle; }
          thead th { background-color: #f0f0f0; }
          .bg-secondary{border-radius:5px; padding:2px;}
          .border-box { border: 1px solid #ccc; padding: 5px; }
          .row { display: flex; flex-wrap: wrap; margin: 1rem 0; }
          .text-end { text-align: right; }
           .print-content,
           .print-content * { font-size: 14px !important; }
           .print-content { background: #fff; width: 100%; }
           @media print { .bg-secondary {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        background-color: red !important;
        color:white; } }
        </style>
      </head>
      <body onload="window.print(); window.close();">
        <div class="print-content">${printElement.innerHTML}</div>
      </body>
    </html>
  `);
  printWindow.document.close();
};
const downloadModal = async () => {
  await nextTick();
  const modalElement = modalContent.value;
  if (!modalElement) return;
  const clone = modalElement.cloneNode(true);
  clone.style.width = "900px";
  clone.style.maxWidth = "900px";
  clone.style.fontSize = "14px";
  clone.style.background = "#fff";
  clone.style.position = "absolute";
  clone.style.left = "-9999px";
  document.body.appendChild(clone);
  try {
    const canvas = await html2canvas(clone, {
      scale: 2,
      useCORS: true,
      windowWidth: 900,
    });
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: "a4",
    });
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = (canvas.height * pageWidth) / canvas.width;
    pdf.addImage(imgData, "PNG", 0, 0, pageWidth, pageHeight);
    pdf.save("marks-report.pdf");
  } catch (error) {
    console.error("Error generating PDF:", error);
  } finally {
    document.body.removeChild(clone);
  }
};
const prepareModal = async (item, action) => {

  const subMarks = (Array.isArray(item.subMarks) ? item.subMarks : []).map(
    (record) =>
      Object.fromEntries(
        Object.entries(record || {}).flatMap(([subjectName, subject]) => {
          if (
            !subject?.participation ||
            typeof subject.participation !== "object" ||
            Array.isArray(subject.participation)
          ) {
            return [];
          }

          const participation = { ...subject.participation };
          delete participation.v;
          const hasNonEmptyParticipation = Object.values(participation).some(
            (value) =>
              value != null &&
              (typeof value !== "string" || value.trim() !== ""),
          );

          return hasNonEmptyParticipation
            ? [[subjectName, { ...subject, participation }]]
            : [];
        }),
      ),
  );

  selectedRecord.value = subMarks.length > 1 ? { ...item, subMarks } : item;
  delete selectedRecord.value.__v;
  await prepareAttendanceModal(item);
  await nextTick();

  if (action === "print") {
    await print();
  } else if (action === "download") {
    await downloadModal();
  }
};
const currentExamSetup = computed(() => {
  return examSetupList.value.filter(
    (setup) =>
      setup.clsID === Obj.value.clsID &&
      setup.sectionID === Obj.value.sectionID &&
      setup.examTypeID === Obj.value.examID,
  );
});

const getSubjectSetup = (subject) => {
  return currentExamSetup.value.find((s) => s.subID === subject) || null;
};
const selectedMarks = computed(() => selectedRecord.value?.subMarks?.[0] || {});
const obtainedMarks = computed(() => {
  return Object.values(selectedMarks.value || {}).reduce(
    (sum, mark) => sum + Number(mark?.value ?? 0),
    0,
  );
});

const totalMarks = computed(() => {
  return (
    Array.isArray(currentExamSetup.value) ? currentExamSetup.value : []
  ).reduce((sum, item) => sum + Number(item?.totalMarks ?? 0), 0);
});

const percentage = computed(() => {
  const total = Number(totalMarks.value) || 0;
  if (!total) return "0.00";
  return ((obtainedMarks.value / total) * 100).toFixed(2);
});
const result = computed(() => {
  const subjectEntries = Object.entries(selectedMarks.value || {});
  const hasFail = subjectEntries.some(([subject, mark]) => {
    const passMark = getSubjectSetup(subject)?.passMark ?? 0;
    return Number(mark?.value ?? 0) < Number(passMark);
  });
  return hasFail ? "FAIL" : "PASS";
});

const formattedCurrentDate = computed(() => {
  const today = new Date();
  return today.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
});
const progress = ref(0);
const loadList = async ({ clsID, sectionID, examID }) => {
  let direction = 1;
  let progressInterval = setInterval(() => {
    progress.value += direction;
    if (progress.value >= 100) {
      progress.value = 0;
    }
  }, 100);
  try {
    const response = await api.get(`/marks/${clsID}/${sectionID}/${examID}`);
    markList.value = Array.isArray(response.data) ? response.data : [];
    return markList.value;
  } catch (error) {
    msgObj.value = {
      msg: error.response?.data?.message || "Failed to load marks.",
      role: "danger",
      show: true,
    };
    return null;
  } finally {
    progress.value = 0;
    clearInterval(progressInterval);
  }
};
const loadStudents = async () => {
  if (Obj.value.clsID && Obj.value.sectionID) {
    const res = await api.get(
      `/students/clssection/${Obj.value.clsID}/${Obj.value.sectionID}`,
    );
    drpList.value = res.data.filter((stu) => stu.active === true);
  } else {
    drpList.value = [];
  }
};
const changeClass = (classID) => {
  if (Obj.value.clsID === classID) return;

  Obj.value.clsID = classID;
  Obj.value.sectionID = "";
  Obj.value.studentID = "";
  drpList.value = [];
};
const listData = async () => {
  if (!appliedFilters.value.clsID || !appliedFilters.value.sectionID) {
    return;
  }
  const res = await api.get(
    `/students/clssection/${appliedFilters.value.clsID}/${appliedFilters.value.sectionID}`,
  );
  const Students = res.data.filter((stu) => stu.active === true);
  const existingStudentIDs = filteredMarkList.value.map(
    (mark) => mark.studentID,
  );
  if (appliedFilters.value.studentID) {
    const selectedStu = Students.find(
      (stu) => stu._id === appliedFilters.value.studentID,
    );
    if (selectedStu && !existingStudentIDs.includes(selectedStu._id)) {
      List1.value = [selectedStu];
    } else {
      List1.value = [];
    }
  } else {
    List1.value = Students.filter(
      (student) => !existingStudentIDs.includes(student._id),
    );
  }
};

const goClicked = async () => {
  filteredMarkList.value = [];
  List1.value = [];
  formReady.value = false;
  const fields = {
    Class: { value: Obj.value.clsID, validators: [isRequired] },
    Section: { value: Obj.value.sectionID, validators: [isRequired] },
    ExamType: { value: Obj.value.examID, validators: [isRequired] },
  };
  errors.value = validateForm(fields);

  if (Object.keys(errors.value).length === 0) {
    appliedFilters.value = { ...Obj.value };
    const setupList = Array.isArray(examSetupList.value)
      ? examSetupList.value.filter(
        (s) =>
          s.clsID === appliedFilters.value.clsID &&
          s.sectionID === appliedFilters.value.sectionID &&
          s.examTypeID === appliedFilters.value.examID,
      )
      : [];
    if (!setupList.length) {
      formReady.value = false;
      msgObj.value = {
        msg: "Exam setup details not found for this Class, Section & Exam Type.",
        role: "danger",
        show: true,
      };
      return;
    }
    const subjectsForClass = Array.isArray(subList.value)
      ? subList.value.filter((s) => s.clsID === appliedFilters.value.clsID)
      : [];
    const subjectNames = subjectsForClass.map((s) => s.name);
    if (!subjectNames.length) {
      formReady.value = false;
      msgObj.value = {
        msg: "No subjects found for this class. Please check subject setup.",
        role: "danger",
        show: true,
      };
      return;
    }
    const missingSubjects = [];
    const allSubjectsValid = subjectNames.every((sub) => {
      const setup = setupList.find(
        (su) =>
          su.subID &&
          su.subID.trim().toLowerCase() === sub.trim().toLowerCase(),
      );
      if (!setup || !setup.totalMarks || !setup.passMark) {
        missingSubjects.push(sub);
        return false;
      }
      return true;
    });

    if (!allSubjectsValid) {
      formReady.value = false;
      msgObj.value = {
        msg: "Marks not found for all subjects in exam setup",
        role: "danger",
        show: true,
      };
      return;
    }

    const fetchedMarks = await loadList(appliedFilters.value);
    if (fetchedMarks === null) return;
    await loadStudents();
    let filtered = fetchedMarks.filter((item) => {
      const student = drpList.value.find((entry) => entry._id === item.studentID);
      return student?.active === true;
    });
    if (appliedFilters.value.studentID) {
      filtered = filtered.filter(
        (item) => item.studentID === appliedFilters.value.studentID,
      );
    }
    filteredMarkList.value = filtered;
    await nextTick();
    await listData();
    formReady.value = true;
  }
};

const Curricular = (Obj, value, key) => {
  const normalizeLabel = (label) => String(label ?? "").replace(/[’‘]/g, "'");
  const matchingItem = (Array.isArray(Obj) ? Obj : []).find(
    (item) => normalizeLabel(item?.[key]) === normalizeLabel(value),
  );

  if (key == 'subject') {
    return matchingItem?.subjectMarks;
  }
  if (key == 'activity' || key == 'marks') {
    return matchingItem?.marks;
  }
  return "";
}

const save = async (index) => {
  let student = List1.value[index];
  delete student.__v;
  let marksData = {};
  const hasPreSum = examList.value.find(
    (exam) => exam._id === Obj.value.examID,
  )?.sum;
  filteredSubjects.value.forEach((sub) => {
    const preSumKey = `${sub.name}_preSum`;
    marksData[sub.name] = {
      value: student[sub.name] || 0,
      participation: Object.entries(student)
        .filter(([key]) => key.includes("__") && key.includes(sub.name))
        .reduce((acc, [key, value]) => {
          const type = key.split("__")[1];
          acc[type] = value;
          return acc;
        }, {}),
      ...(hasPreSum
        ? { [preSumKey]: Number(student[preSumKey]) || 0 }
        : {}),
    };
  });

  let saveData = {
    clsID: Obj.value.clsID,
    sectionID: Obj.value.sectionID,
    studentID: student._id,
    rollNo: student.rollNo,
    examID: Obj.value.examID,
    subMarks: [marksData],
    remarks: student.remarks,
    assessment: popUpData.value
  };

  try {
    await api.post("/marks/add", saveData);
    msgObj.value = {
      msg: "Marks saved successfully",
      role: "success",
      show: true,
    };
    List1.value.splice(index, 1);
    await goClicked();
  } catch (error) {
    console.error(error);
  }
};

const reset = async () => {
  Obj.value = { clsID: "", sectionID: "", examID: "", studentID: "" };
  appliedFilters.value = { clsID: "", sectionID: "", examID: "", studentID: "" };
  subMarks.value = { RollNo: "", student: "" };
  errors.value = {};
  markList.value = [];
  filteredMarkList.value = [];
  List1.value = [];
  drpList.value = [];
  formReady.value = false;
};
const delRecord = async () => {
  if (!delID.value._id) return;
  try {
    await api.delete(`/marks/${delID.value._id}`);
    msgObj.value = {
      msg: "Marks Deleted Successfully.",
      role: "danger",
      show: true,
    };
    await goClicked();
    await listData();
  } catch (error) {
    console.error("Error deleting timetable record:", error);
  } finally {
    delID.value = {};
  }
};
const getUrl = (img) => {
  let imgUrl = !img
    ? "/images/Logo.png"
    : img.startsWith("..")
      ? img.substring(2)
      : img;

  const base = process.env.VUE_APP_API_URL.replace(/\/+$/, "");
  const path = imgUrl.replace(/^\/+/, "");
  return `${base}/${path}`;
};
onMounted(() => {
  loadGrades();
  const saved = localStorage.getItem("marksList");
  if (saved) {
    List.value = JSON.parse(saved);
  }
  loadExamSetup();
});
</script>
<style>
.cusSub {
  width: 8%;
}

.participation-container {
  width: 100%;
}

.participation-item {
  flex: 0 0 calc(50% - 0.25rem);
  min-width: 0;
}

.participation-input {
  min-width: 20px;
  padding: 0.1rem 0.1rem;
}

.mark-static th,
.mark-static td {
  padding: 2px;
}

.marks-table-wrapper {
  max-height: 1vh;
  overflow: auto;
}

.marks-table-wrapper .custom-table {
  border-collapse: separate;
  border-spacing: 0;
}

.marks-table-wrapper .custom-table thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: #fff;
}

.no-spin {
  width: 40px;
  margin: 0;
  padding: 4px;
  -moz-appearance: textfield;
}

.no-spin::-webkit-inner-spin-button,
.no-spin::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
